import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import ChannelSelect from '../Editor/ChannelSelect';
import LuciPropTypes from '../../propTypes/';
import { Button, ButtonIcon } from '../../styled-components/';
import { actions as assetActions } from '../../actions/asset';

const Footer = styled.div`
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ButtonContainer = styled.div`
  justify-content: flex-end;
  display: flex;
  flex-direction: row;

  > button {
    margin-left: 0.5rem;
  }
`;

class ClipperFooter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedChannel: props.defaultChannel
    };

    this.handleOnClickSave = this.handleOnClickSave.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ selectedChannel: nextProps.defaultChannel });
  }

  channelChanged = event => {
    this.setState({ selectedChannel: event.target.value });
    this.props.updateTemplateProperty(
      'default channel',
      event.target.options[event.target.selectedIndex].text
    );
  };

  handleOnClickSave = () => {
    this.props.onClickSaveChanges();
    this.props.onClose();
  };

  renderSaveButton() {
    return this.props.asset.editing && this.props.asset.isMosObject ? (
      <Button onClick={this.handleOnClickSave}>
        <ButtonIcon src="images/floppy_disk.png" /> Save Changes
      </Button>
    ) : (
      <Button onClick={this.props.onClickAddToTL}>
        <ButtonIcon src="images/add2.png" /> Add To TL
      </Button>
    );
  }

  render() {
    return (
      <Footer>
        <ChannelSelect
          channelList={this.props.channelList}
          selectedChannel={this.state.selectedChannel}
          onChanged={this.channelChanged}
        />
        <ButtonContainer>
          <Button onClick={this.props.generatePreview} disabled={this.props.generatingPreview}>
            <ButtonIcon src="images/window_dialog.png" /> Preview
          </Button>
          {this.renderSaveButton()}
        </ButtonContainer>
      </Footer>
    );
  }
}

ClipperFooter.propTypes = {
  asset: LuciPropTypes.Asset.isRequired,
  channelList: LuciPropTypes.ChannelList.isRequired,
  defaultChannel: PropTypes.string.isRequired,
  updateTemplateProperty: PropTypes.func.isRequired,
  generatingPreview: PropTypes.bool.isRequired,
  generatePreview: PropTypes.func.isRequired,
  onClickAddToTL: PropTypes.func.isRequired,
  onClickSaveChanges: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  let defaultChannel = '';
  if (state.asset.templateDefinition && state.asset.templateDefinition.properties) {
    defaultChannel = state.asset.templateDefinition.properties['default channel'] || '';
  }
  return {
    asset: state.asset,
    channelList: state.asset.channelList,
    defaultChannel,
    generatingPreview: state.asset.generatingPreview
  };
};

const mapActionCreators = {
  updateTemplateProperty: assetActions.updateTemplateProperty,
  generatePreview: assetActions.generatePreview,
  onClickAddToTL: assetActions.createNewMosObject,
  onClickSaveChanges: assetActions.updateMosObject,
  onClose: assetActions.endEditAsset
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(ClipperFooter);



// WEBPACK FOOTER //
// ./app/components/Clipper/ClipperFooter.js